const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import BJLTableView from "./bjl_table_view";
import BJLTableModel from "./bjl_table_model";
import BaseTableModule from "../../../longhudou/module/table/base_table_module";
import * as ProtoRoom from  "../../../longhudou/net/proto/longhudou_room"
import * as ProtoGame from  "../../net/proto/bjl_game"
import NetMsgData from "../../net/bjl_net_msg_data_game"
import EventManager from "../../../../manager/event_manager";
import BJLRoadMapInfo from "../roadmapinfo/BJLRoadMapInfo";
import ModuleManager from "../../../../framework/core/module_manager";

@ccclass
@moduleInit("BJLTableModule")
export default class BJLTableModule extends BaseTableModule<BJLTableView, BJLTableModel>  {

    constructor() {
        super()
        this.windowPrefabResPath = 'package/longhudou/bjl_table';
        this.viewType = BJLTableView;
        this.modelType = BJLTableModel;
        this.betNameList = ["1", "2", "3", "4", "5"] //(1:闲 2:庄 3:和 4:闲对子 5:庄对子)
    }

    protected onButtonClickName(name: string) {
        super.onButtonClickName(name)
        switch (name) {
            case "ResultBtn":
                ModuleManager.instance.showModule(BJLRoadMapInfo, this.view.roadMapDatas)
                break;
            default:
                break;
        }
    }

    registNetMsg() {
        super.registNetMsg()
        let self = this
        self.model.subscibeMsgEvent<ProtoRoom.LongHuDouRoom.RoomInfo>(NetMsgData.RoomInfo, function (protoData) {
            self.roomInfoEvent(protoData)
        })
        //押注成功
        self.model.subscibeMsgEvent<ProtoGame.Game.BetRsp>(NetMsgData.BetReq, function (protoData: ProtoGame.Game.IBetRsp) {
            self.betRspEvent(protoData)
        })

        //刷新押注数据
        self.model.subscibeMsgEvent<ProtoGame.Game.BetBroadCast>(NetMsgData.BetData, function (protoData: ProtoGame.Game.IBetBroadCast) {
            self.betBroadCastEvent(protoData)
        })
        //押注结果
        self.model.subscibeMsgEvent<ProtoGame.Game.BetResult>(NetMsgData.BetResult, function (protoData) {
            self.currentResult = protoData
        })

        //刷新最近20场记录
        self.model.subscibeMsgEvent<ProtoGame.Game.BetResultHistory>(NetMsgData.TwentyTimesResult, function (protoData: ProtoGame.Game.BetResultHistory) {
            if (self.twentyTimesResult == null){
                self.view.refreshSelectRoadMap(protoData.result)
                EventManager.instance.dispatch("event_update_betresulthistory", protoData.result)
            }
            self.twentyTimesResult = protoData.result
            
        })

        //获取在线玩家
        self.model.subscibeMsgEvent<ProtoGame.Game.OnlinePlayersRsp>(NetMsgData.GetOnlinePlayers, function (protoData) {
            self.openOnlinePlayerEvent(protoData)
        })

        //上下庄
        self.model.subscibeMsgEvent<ProtoGame.Game.BankerRsp>(NetMsgData.BankerReq, function (protoData) {
            self.bankerRspEvent()
        })

        //更新上庄请求列表
        self.model.subscibeMsgEvent<ProtoGame.Game.BankerList>(NetMsgData.WaitBankerList, function (protoData: ProtoGame.Game.IBankerList) {
           self.bankerListEvent(protoData)
        })

        self.model.subscibeMsgEvent<ProtoGame.Game.BankerInfo>(NetMsgData.BankerInfo, function(protoData:ProtoGame.Game.IBankerInfo){
           self.bankerInfoEvent(protoData)
        })

        //收到离开房间
        self.model.subscibeMsgEvent<ProtoRoom.LongHuDouRoom.LeaveRsp>(NetMsgData.LeaveRoom, function (protoData: ProtoRoom.LongHuDouRoom.ILeaveRsp) {
            self.leaveRspEvent(protoData)
        })

        self.model.subscibeMsgEvent<ProtoRoom.LongHuDouRoom.NotifyMsg>(NetMsgData.NotifyMsg, function (protoData: ProtoRoom.LongHuDouRoom.INotifyMsg) {
            self.notifyMsgEvent(protoData)
        })
    }


    //房间信息得改变
    roomInfoEvent(roomData) {
        let self = this
        this.view.updateTopInfo(roomData, this.roomStatus)
        switch (roomData.state) {
            case 0: //上庄
                break
            case 1: //开始
                break;
            case 2: //洗牌
                break;
            case 3: // 准备
                self.eventDispatch('Game_Table_Start');
                break
            case 4: //发牌
                this.isFristBetAim = true
                this.localBetIndex = 0
                this.betIndex = 0
                this.initBetData = null
                break
            case 5: //下注
                this.isCanBet = true
                if (this.isFristBetAim) {
                    this.view.showBetTips(true, () => {
                        self.isCanBet = true
                        self.view.updateJettonMask(self.myGold - self.retainCount, false)
                    })
                    self.isFristBetAim = false
                }
                self.updatePlayerInfo(roomData)
                break
            case 6: //开牌
                self.isCanBet = false
                self.updatePlayerInfo(roomData)
                if (this.roomStatus != null) {
                    this.view.showResulet(this.currentResult, function () {
                        self.view.refreshSelectRoadMap(self.twentyTimesResult)
                        EventManager.instance.dispatch("event_update_betresulthistory", self.twentyTimesResult)
                    })
                }
                break
            case 7: //派奖
                self.updatePlayerInfo(roomData)
                if  (this.initBetData != null){
                    self.view.playResultAmin(this.currentResult, this.initBetData.totalData, 0)
                }
                break
            default:
                break;
        }

        if (this.roomStatus == null) {
            if(roomData.state != 3){
                self.eventDispatch('Game_Table_Start');
            }
            self.updatePlayerInfo(roomData)
            if (roomData.state >= 6) {
                this.view.showResulet(this.currentResult, function () {
                    self.view.refreshSelectRoadMap(self.twentyTimesResult)
                    EventManager.instance.dispatch("event_update_betresulthistory", self.twentyTimesResult)
                }, false)
            }
        }
        this.roomStatus = roomData.state
        this.showBetTime(roomData.betTimeout, this.roomStatus == 5)
    }
}